import React, { useState } from "react";
import { SELLER_REGISTRATION } from "../../../../config/api";
import axios from "axios";
import TermsAndConditions from "./TermsAndConditions";
import { useForm } from "react-hook-form";
import { Box } from "@mui/material";
import { Checkbox, H4 } from '@tviklax/ui-components';
import FullPageLoader from "../../../../components/common/FullPageLoader";
import { toast } from "react-toastify";
import { SellerRegistrationFormData } from "../../components";

interface CompleteRegistrationFormProps {
    formData: SellerRegistrationFormData;
    handleFormSubmit: () => void;
    formId: string;
    setNextDisabled?: (disabled: boolean) => void;
    setNextLabel?: (label?: string) => void;
}

const CompleteRegistrationForm: React.FC<CompleteRegistrationFormProps> = ({
    formData,
    handleFormSubmit,
    formId,
    setNextDisabled,
    setNextLabel,
}) => {
    const [fullPageLoading, setFullPageLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors },
    } = useForm({
        mode: "all",
        defaultValues: formData,
    });

    const onSubmit = () => {
        if (btnDisabled) return;
        setBtnDisabled(true);
        setFullPageLoading(true);
        setNextDisabled?.(true);
        setNextLabel?.("Submitting...");
        axios
            .post(SELLER_REGISTRATION, formData)
            .then((response) => {
                if (response?.data?.success && response?.data?.code === 200) {
                    handleFormSubmit();
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error) => {
                if (
                    !error?.response?.data?.success &&
                    error?.response?.status === 422
                ) {
                    const validation_errors = error?.response?.data?.message;
                    Object.entries(validation_errors).forEach(([field, messages]: [string, any]) => {
                        setError(field as any, {
                            type: "manual",
                            message: messages[0],
                        });
                    });
                } else {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => {
                setBtnDisabled(false);
                setFullPageLoading(false);
                setNextDisabled?.(false);
                setNextLabel?.("Submit");
            });
    };

    return (
        <form id={formId} onSubmit={handleSubmit(onSubmit)}>
            <FullPageLoader loading={fullPageLoading} color="#f86400" />

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ pb: 1, pt: 1 }}>
                    <H4 style={{ fontWeight: 600 }}>Complete Registration</H4>
                </Box>

                <TermsAndConditions />

                <Box sx={{ mt: 4 }}>
                    <Checkbox
                        {...register("terms" as any, {
                            required: "Please read and accept the terms and conditions",
                        })}
                        label="I agree to the Terms & Conditions"
                        error={errors.terms?.message as string}
                    />
                </Box>

            </Box>
        </form>
    );
};

export default CompleteRegistrationForm;
